import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataTravelMemberNationalityService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-travel-member-nationality/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-travel-member-nationality/list', data);
  }

  create(data: any) {
    return this._api.post('data-travel-member-nationality/create', data);
  }

  update(data: any) {
    return this._api.post('data-travel-member-nationality/update', data);
  }

  remove(id: number) {
    return this._api.post('data-travel-member-nationality/remove/id/' + id);
  }
}
